<template>
  <p class="mt-4 text-ROJO_LEON text-lg md:text-lg flex justify-center items-center font-bold">
    <img class="h-2 mx-1 md:items-start" :src="'/img/shared/point-arrow-iconv2.svg'" alt="point-arrow-icon" />
    Ingresa tu ubicación
  </p>
  <p class="text-black text-xs md:text-sm flex justify-center items-center font-bold">Para ver {{ texto_producto }}
    disponibles cerca de tu zona.</p>

  <div v-if="isLoading" class="py-4 w-full px-5 rounded-md text-sm font-medium text-gray-900 bg-white border border-gray-200 justify-center inline-flex items-center h-full mt-4">
    <LoaderSvg strokeColor="#BD2025" sizeClass="w-4 h-4" />
  </div>

  <!-- Input dirección -->
  <div v-show="!isLoading" class="relative flex items-center w-full mt-4">
    <span class="absolute inset-y-0 left-0 flex items-center pl-2" v-if="address == ''">
      <img src='/img/home/ubicacion-icono.svg' alt="" />
    </span>

    <input ref="inputRef" :disabled="!isEnabled" @focus="handleFocus" @blur="handleBlur"
      @input="handleAddressChange($event.target.value)" type="text" :value="localAddress"
      placeholder="Ingresa tu dirección" :class="[
        category == NEGOCIOS.BATERIAS ? 'input-custom' : '',
        !isEnabled ? 'opacity-60 cursor-not-allowed' : 'cursor-text',
        isFocused ? 'input-focused' : ''
      ]"
      class="resaltar_programatico w-full px-8 py-2 pl-10 border rounded-md border-none placeholder-black placeholder:text-center" />

  </div>

</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import LoaderSvg from "~/components/Ui/LoaderSvg.vue";
import { NEGOCIOS } from "~/constants/negocios";
import useGoogleServices from "~/composables/useGoogleServices";
import useUbicacionUsuario from "~/composables/useUbicacionUsuario";

const modo_sistema = useState('modo_sistema');
const { ubication, address, setAddress } = useCartBridge();

const props = defineProps({
  searchType: {
    type: Number,
    required: true,
  },
  isEnabled: {
    type: Boolean,
    default: true
  }
});

const category = modo_sistema.value;

const { trace } = useTraceLog("components->InputSearch.vue");
const inputRef = ref(null);
const localAddress = ref("");
const isLoading = computed(() => ubication.value.isLoading);
const isFocused = ref(false);
const emit = defineEmits(["cambioUbicacion"]);
const texto_producto = computed(() => {
  return category === NEGOCIOS.BATERIAS ? 'baterías' : 'neumáticos';
});

const { seleccionarUbicacion } = useUbicacionUsuario();
const { crearAutocomplete } = useGoogleServices('InputSearch');
const { configurarInput } = crearAutocomplete({ alSeleccionar: seleccionarUbicacion });

// Inicializar localAddress con el valor del store
localAddress.value = ubication.value.address;

const handleAddressChange = (value) => {
  trace("Valor del input cambiado a: ", value);
  emit("cambioUbicacion", value, props.searchType);
};

const handleFocus = () => {
  isFocused.value = true;
};

const handleBlur = () => {
  isFocused.value = false;
};

onMounted(() => {
  setAddress("");
  configurarInput(inputRef.value);
});

// Watch para cambios en el store
watch(ubication, (newUbication) => {
  trace("Watch() newUbication: ", newUbication);
  localAddress.value = newUbication.address;

  // Mantiene el texto visible igual a la dirección guardada
  if (inputRef.value) {
    inputRef.value.value = newUbication.address || "";
  }

  emit("cambioUbicacion", newUbication.address, props.searchType);
});

</script>

<style scoped>
.input-custom::placeholder {
  text-align: left;
}

.input-focused {
  outline: 2px solid #238B00;
  outline-offset: 0;
  border-color: #238B00 !important;
  caret-color: #238B00;
}
</style>